export default "__VITE_ASSET__f135bfca__"